module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row gutter-md ext-form-config"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('h4', {
    staticClass: "separator"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.external_form.frontend_actions')) + "\n    ")]), _vm._v(" "), _c('email-list', {
    attrs: {
      "label": _vm.$t('ui.external_form.send_notification_to')
    },
    model: {
      value: (_vm.config.actions.send_team_confirmation_mail.emails),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_team_confirmation_mail, "emails", $$v)
      },
      expression: "config.actions.send_team_confirmation_mail.emails"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "status-switch"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.success_message.status),
      expression: "config.actions.success_message.status"
    }],
    attrs: {
      "type": "radio",
      "id": "success_message",
      "value": "enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.config.actions.success_message.status, "enabled")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.config.actions.success_message, "status", "enabled")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "success_message"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.external_form.success_message')))])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.redirect_to.status),
      expression: "config.actions.redirect_to.status"
    }],
    attrs: {
      "type": "radio",
      "id": "redirect_to",
      "value": "enabled"
    },
    domProps: {
      "checked": _vm._q(_vm.config.actions.redirect_to.status, "enabled")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.config.actions.redirect_to, "status", "enabled")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "redirect_to"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.external_form.redirection_url')))])])]), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.config.actions.success_message.status === 'disabled'
    }
  }, [_c('field', {
    attrs: {
      "label": "empty",
      "placeholder": "Thank you!",
      "type": "textarea"
    },
    model: {
      value: (_vm.config.actions.success_message.content),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.success_message, "content", $$v)
      },
      expression: "config.actions.success_message.content"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'hidden': _vm.config.actions.redirect_to.status === 'disabled'
    }
  }, [_c('field', {
    attrs: {
      "label": "empty",
      "placeholder": "https://fanomena.io",
      "type": "text"
    },
    model: {
      value: (_vm.config.actions.redirect_to.url),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.redirect_to, "url", $$v)
      },
      expression: "config.actions.redirect_to.url"
    }
  })], 1)])])]), _vm._v(" "), _c('h4', {
    staticClass: "separator"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('ui.external_form.follow_up')) + "\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "vertical-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.board_businesskit.status),
      expression: "config.actions.board_businesskit.status"
    }],
    staticClass: "is-inline-block vertical-center",
    attrs: {
      "type": "checkbox",
      "id": "bk_status",
      "true-value": "enabled",
      "false-value": "disabled",
      "name": "business_kit_boarding_status"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.actions.board_businesskit.status) ? _vm._i(_vm.config.actions.board_businesskit.status, null) > -1 : _vm._q(_vm.config.actions.board_businesskit.status, "enabled")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.actions.board_businesskit.status,
          $$el = $event.target,
          $$c = $$el.checked ? ("enabled") : ("disabled");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.actions.board_businesskit, "status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.actions.board_businesskit, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.actions.board_businesskit, "status", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-text",
    attrs: {
      "for": "bk_status"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.external_form.bk_boarding')) + "\n        ")])]), _vm._v(" "), _c('field', {
    staticClass: "select-field",
    attrs: {
      "readonly": _vm.config.actions.board_businesskit.status === 'disabled' ? true : false,
      "collection": _vm.businessKitCollection,
      "type": "select",
      "name": "business_kit_boarding",
      "label": "empty",
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.config.actions.board_businesskit.eventbaxx_event_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.board_businesskit, "eventbaxx_event_foreign_id", $$v)
      },
      expression: "config.actions.board_businesskit.eventbaxx_event_foreign_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vertical-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.board_businesskit.send_directly),
      expression: "config.actions.board_businesskit.send_directly"
    }],
    staticClass: "is-inline-block",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.config.actions.board_businesskit.status === 'disabled' ? true : false,
      "true-value": false,
      "false-value": true,
      "id": "bk_send_directly"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.actions.board_businesskit.send_directly) ? _vm._i(_vm.config.actions.board_businesskit.send_directly, null) > -1 : _vm._q(_vm.config.actions.board_businesskit.send_directly, false)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.actions.board_businesskit.send_directly,
          $$el = $event.target,
          $$c = $$el.checked ? (false) : (true);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.actions.board_businesskit, "send_directly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.actions.board_businesskit, "send_directly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.actions.board_businesskit, "send_directly", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-text",
    class: {
      'text-disabled': _vm.config.actions.board_businesskit.status === 'disabled' ? true : false
    },
    attrs: {
      "for": "bk_send_directly"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.external_form.send_directly')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "is-block separator"
  }, [_c('div', {
    staticClass: "vertical-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.actions.send_lead_confirmation_mail.status),
      expression: "config.actions.send_lead_confirmation_mail.status"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "enabled",
      "false-value": "disabled",
      "name": "send_team_confirmation_mail_status",
      "id": "lead_mail_status"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.actions.send_lead_confirmation_mail.status) ? _vm._i(_vm.config.actions.send_lead_confirmation_mail.status, null) > -1 : _vm._q(_vm.config.actions.send_lead_confirmation_mail.status, "enabled")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.actions.send_lead_confirmation_mail.status,
          $$el = $event.target,
          $$c = $$el.checked ? ("enabled") : ("disabled");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.actions.send_lead_confirmation_mail, "status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.actions.send_lead_confirmation_mail, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "status", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-text",
    attrs: {
      "for": "lead_mail_status"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('ui.external_form.email_notification')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "max-width"
  }, [_c('field', {
    attrs: {
      "collection": _vm.emailTemplateCollection,
      "disabled": _vm.config.actions.send_lead_confirmation_mail.status === 'disabled' ? true : false,
      "type": "select",
      "name": "send_lead_confirmation_mail_template",
      "label": _vm.$t('ui.external_form.email_template'),
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.email_template_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "email_template_foreign_id", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.email_template_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "disabled": _vm.NoPresentEmailTemplateOrDisabled(_vm.config),
      "name": "send_lead_confirmation_mail_subject",
      "label": _vm.$t('ui.external_form.mail_subject')
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.subject),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "subject", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.subject"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "disabled": _vm.NoPresentEmailTemplateOrDisabled(_vm.config),
      "name": "send_lead_confirmation_mail_url",
      "label": _vm.$t('ui.external_form.mail_url')
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.url),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "url", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.url"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "disabled": _vm.NoPresentEmailTemplateOrDisabled(_vm.config),
      "name": "send_lead_confirmation_mail_cta",
      "label": _vm.$t('ui.external_form.mail_cta')
    },
    model: {
      value: (_vm.config.actions.send_lead_confirmation_mail.cta_text),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.send_lead_confirmation_mail, "cta_text", $$v)
      },
      expression: "config.actions.send_lead_confirmation_mail.cta_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('h5', [_vm._v("\n      Integrations\n    ")]), _vm._v(" "), _c('go-to-webinar', {
    attrs: {
      "active": _vm.config.actions.board_citrix.status === 'enabled' ? true : false
    },
    on: {
      "activeInput": function($event) {
        return _vm.switchCitrixStatus()
      }
    },
    model: {
      value: (_vm.config.actions.board_citrix.citrix_webinar_keys),
      callback: function($$v) {
        _vm.$set(_vm.config.actions.board_citrix, "citrix_webinar_keys", $$v)
      },
      expression: "config.actions.board_citrix.citrix_webinar_keys"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6243bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/external_forms/ExternalFormConfiguration.vue
// module id = 1919
// module chunks = 0